export default {
  id: "page9",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      number: "23",
      label:
        "Jak często jada Pan(i) następujące rodzaje <span class='has-text-danger'>gotowych produktów z lodówki</span>?",
      info:
        "Dla każdego deseru (w wierszu) proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością."
    },
    {
      type: "choice_names",
      options: [
        "Raz w tygodniu lub częściej",
        "1-2 razy w miesiącu",
        "Raz na 2-3 miesiące",
        "Rzadziej",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      label: "Deser z bitą śmietaną typu Satino, Deser z koroną",
      type: "radio",
      id: "kategoria5_deserSmietana",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Puszysty deser z bitą śmietaną typu Paradis, Sonata",
      type: "radio",
      id: "kategoria5_deserSmietanaPusz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: 'Deser "dziecięcy" typu Monte, Mikuś',
      type: "radio",
      id: "kategoria5_monte",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Deser budyniowy, puddingowy bez bitej śmietany, typu Smakija, Deli, Gratka, Serduszko",
      type: "radio",
      id: "kategoria5_budyniowy",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Ryż na słodko",
      type: "radio",
      id: "kategoria5_ryzSlodki",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Kaszka",
      type: "radio",
      id: "kategoria5_kaszka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Galaretka",
      type: "radio",
      id: "kategoria5_galaretka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Jogurt owocowy",
      type: "radio",
      id: "kategoria5_jogurtOwoce",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Serek smakowy typu Danio",
      type: "radio",
      id: "kategoria5_serekDanio",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: 'Serek "dziecięcy" typu Danonki, Bakuś',
      type: "radio",
      id: "kategoria5_serekDanonki",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Jogurt naturalny",
      type: "radio",
      id: "kategoria5_jogurtNaturalny",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Desery proteinowe/ high protein typu puddingi, musy/ mousse, kaszki, ryże itp.",
      type: "radio",
      id: "kategoria5_deseryProteinowe",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Desery wege/ wegańskie typu puddingi, musy/ mousse, kaszki, ryże",
      type: "radio",
      id: "kategoria5_deseryWege",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page9.js